import styled from "styled-components";

export const CloseButton = styled.div`
  position: absolute;
  inset: 0 0 0 auto;
  height: 40px;
  display: none;
  align-items: center;
  cursor: pointer;
  border-radius: 8px;
  padding: 0 3px;
  background: ${({ theme }) => theme.bg.primary};
`;

export const Container = styled.div`
  position: relative;
  margin-top: 8px;

  &:hover ${CloseButton} {
    display: flex;
  }
`;

export const TextContainer = styled.div`
  position: relative;

  input {
    padding: 4px 8px 4px 30px;

    &::placeholder {
      color: ${({ theme, isLink }) =>
        isLink ? theme.text.brand : theme.border.black50};
    }
  }

  & > span {
    position: absolute;
    left: 4px;
    top: 8px;
    color: ${({ theme }) => theme.text.input};
  }
`;

export const Input = styled.input`
  padding: 4px 8px;
  height: 40px;
  background-color: ${({ theme }) => theme.bg.primary};
  border-radius: 8px;
  box-sizing: border-box;
  border: none;
  width: 100%;

  &:focus {
    outline: ${({ theme }) => `2px solid ${theme.text.brand}4d`};
    outline-offset: 1px;
    background-color: ${({ theme }) => theme.bg.general};
  }
`;
